<section class="record">
    <span ng-click="toggleDetails()">
        <span class="details-toggle" ng-class="{open:showDetails}"><i class="fa fa-angle-right"></i></span>
        <span c-activity-log-blurb activity="activity"></span> {{message}}
    </span>
</section>
<section class="details" c-toggle="showDetails">
    <c-log-value-change changes="changes" visible="showDetails" />
</section>